module.exports = __webpack_public_path__ + "img/ic_arrow_verte.bcd5f83f.svg";